// extracted by mini-css-extract-plugin
export default {"varsBlock":"SettingsBlock_varsBlock__VhpWN"};